// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { FemaleHolsteinAnimalInList, FemaleHolsteinAnimalInListSchema } from 'api/gen/FemaleHolsteinAnimalInList';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(FemaleHolsteinAnimalInListSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelFemaleHolsteinAnimalInListSchema = excess(requiredPart);

export interface PagedModelFemaleHolsteinAnimalInList extends t.TypeOf<typeof PagedModelFemaleHolsteinAnimalInListSchema> {}
